import app from '@/app';

app.constant('LANGUAGES', ['pt-br', 'en', 'es']);
